/**
 * Card — the standard metric tile used across the admin console.
 * One label, one big value, optional hint underneath. Theme-aware.
 */
export function Card({ label, value, hint }) {
  return (
    <div className="rounded-lg border border-border-default bg-bg-primary px-4 py-3">
      <div className="text-[10px] uppercase tracking-widest text-text-secondary">
        {label}
      </div>
      <div className="text-2xl font-semibold mt-1 font-mono">{value}</div>
      {hint && <div className="text-[11px] text-text-secondary mt-1">{hint}</div>}
    </div>
  );
}
